'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduce2 = require('ramda/src/reduce');

var _reduce3 = _interopRequireDefault(_reduce2);

var _path2 = require('ramda/src/path');

var _path3 = _interopRequireDefault(_path2);

var _propEq2 = require('ramda/src/propEq');

var _propEq3 = _interopRequireDefault(_propEq2);

var _find2 = require('ramda/src/find');

var _find3 = _interopRequireDefault(_find2);

var _templateObject = _taggedTemplateLiteral(['\n    display: inline-block;\n    line-height: 1;\n    margin-top: 12px;\n    margin-left: 0px;\n    max-width: ', ';\n'], ['\n    display: inline-block;\n    line-height: 1;\n    margin-top: 12px;\n    margin-left: 0px;\n    max-width: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _difference_in_calendar_months = require('date-fns/difference_in_calendar_months');

var _difference_in_calendar_months2 = _interopRequireDefault(_difference_in_calendar_months);

var _is_before = require('date-fns/is_before');

var _is_before2 = _interopRequireDefault(_is_before);

var _is_same_month = require('date-fns/is_same_month');

var _is_same_month2 = _interopRequireDefault(_is_same_month);

var _ru = require('date-fns/locale/ru');

var _ru2 = _interopRequireDefault(_ru);

var _experiumPlayerHelpers = require('experium-player-helpers');

var _Age = require('./Age');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var WorkExperienceWrapper = _styledComponents2.default.div(_templateObject, function (_ref) {
    var inline = _ref.inline,
        long = _ref.long;
    return long ? '340px' : inline ? '160px' : '230px';
});

var getWorkExperienceWord = function getWorkExperienceWord(months) {
    var month = months % 12;
    var year = (months - month) / 12;
    var localeYear = ['год', 'года', 'лет'];
    var localeMonth = year ? ['мес.', 'мес.', 'мес.'] : ['месяц', 'месяца', 'месяцев'];

    var yearWord = (0, _Age.getWord)(year, localeYear);
    var monthWord = (0, _Age.getWord)(month, localeMonth);

    return month || year ? (year ? yearWord : '') + ' ' + (month ? monthWord : '') : '';
};

var getWorkExperienceTotalWord = function getWorkExperienceTotalWord(months) {
    var month = months % 12;
    var year = (months - month) / 12;
    var localeYear = ['года', 'лет', 'лет'];
    var localeMonth = ['мес.', 'мес.', 'мес.'];

    var yearWord = (0, _Age.getWord)(year, localeYear);
    var monthWord = (0, _Age.getWord)(month, localeMonth);

    return month || year ? (year ? yearWord : '') + ' ' + (month ? monthWord : '') : '';
};

var WorkExperience = function WorkExperience(_ref2) {
    var items = _ref2.items,
        index = _ref2.index,
        value = _ref2.value,
        _ref2$values = _ref2.values,
        values = _ref2$values === undefined ? [] : _ref2$values,
        _ref2$short = _ref2.short,
        short = _ref2$short === undefined ? false : _ref2$short,
        _ref2$inline = _ref2.inline,
        inline = _ref2$inline === undefined ? false : _ref2$inline,
        _ref2$long = _ref2.long,
        long = _ref2$long === undefined ? false : _ref2$long;

    var fromItem = (0, _find3.default)((0, _propEq3.default)('function_tag', 'from'), items);
    var toItem = (0, _find3.default)((0, _propEq3.default)('function_tag', 'to'), items);

    if (!fromItem || !toItem) {
        return null;
    }

    var fromValue = (0, _path3.default)([fromItem.id, 'value'], value);
    var toValue = (0, _path3.default)([toItem.id, 'value'], value);

    var fromDate = fromValue && fromValue.year > 1900 ? new Date(fromValue.year, fromValue.month, 1) : null;
    var toDate = toValue && toValue.year > 1900 ? new Date(toValue.year, toValue.month, 1) : new Date();

    var diff = fromValue && fromValue.year > 1900 && (toValue || !index) ? (0, _is_same_month2.default)(toDate, fromDate) ? 1 : (0, _difference_in_calendar_months2.default)(toDate, fromDate) : 0;
    var wordDiff = diff > 0 ? getWorkExperienceWord(diff) : '';

    var totalDiff = (0, _reduce3.default)(function (_ref3, dates) {
        var total = _ref3.total,
            min = _ref3.min,
            index = _ref3.index;

        var fromDate = (0, _path3.default)([fromItem.id, 'value'], dates);
        var toDate = (0, _path3.default)([toItem.id, 'value'], dates);

        var toBefore = !min || toDate && (0, _is_before2.default)(new Date(toDate.year, toDate.month, 1), new Date(min.year, min.month, 1));
        var fromBefore = !min || fromDate && (0, _is_before2.default)(new Date(fromDate.year, fromDate.month, 1), new Date(min.year, min.month, 1));
        var diff = (!index || toDate) && fromDate ? (0, _difference_in_calendar_months2.default)(toDate ? toBefore ? new Date(toDate.year, toDate.month, 1) : new Date(min.year, min.month, 1) : new Date(), new Date(fromDate.year, fromDate.month, 1)) + (min && !toBefore ? 0 : 1) : 0;

        return {
            index: index + 1,
            total: toBefore || fromBefore ? total + diff : total,
            min: !min || (fromBefore && (0, _is_before2.default)(new Date(fromDate.year, fromDate.month, 1)), new Date(min.year, min.month, 1)) ? fromDate : min
        };
    }, { total: 0, min: null, index: 0 }, values);
    var totalDiffWord = totalDiff.total > 0 ? getWorkExperienceTotalWord(totalDiff.total) : '';

    return _react2.default.createElement(
        WorkExperienceWrapper,
        { inline: inline, long: long },
        wordDiff && _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_experiumPlayerHelpers.FormattedMessage, { id: 'workExperience' }),
            ' ',
            _react2.default.createElement(
                'b',
                null,
                wordDiff
            ),
            !short && !!totalDiffWord && values.length > 1 && totalDiff.total !== diff ? _react2.default.createElement(
                'span',
                null,
                ' \u0438\u0437 ',
                totalDiffWord
            ) : ''
        )
    );
};

WorkExperience.propTypes = {
    long: _propTypes2.default.bool,
    inline: _propTypes2.default.bool,
    items: _propTypes2.default.array,
    index: _propTypes2.default.number,
    value: _propTypes2.default.object,
    values: _propTypes2.default.array,
    short: _propTypes2.default.bool
};

exports.default = WorkExperience;